<template>
  <v-container fluid fill-height class="grey lighten-3">
    <v-slide-y-transition mode="out-in">
      <v-layout row wrap>
        <v-flex xs12 sm10 offset-sm1 md10 offset-md1 lg10 offset-lg1>
          <v-toolbar flat color="grey lighten-2">
            <v-toolbar-title>Ideamed Live Closing Stock Report</v-toolbar-title>
            <v-divider class="mx-2 black" inset vertical></v-divider>
            <v-spacer></v-spacer>

            <!-- Branch Code Input -->
            <v-text-field
              v-model="branchCode"
              label="Enter Branch Code"
              placeholder="Enter Branch Code (e.g. CMH)"
              maxlength="3"
              counter
              solo
              required
              class="mr-4"
            ></v-text-field>

            <!-- To Date (Today's Date - Readonly) -->
            <v-text-field
              :value="todayDate"
              label="Live"
              prepend-inner-icon="event"
              readonly
              solo
              class="mr-4"
            ></v-text-field>

            <v-btn rounded color="primary" dark @click="apiRequestCogsdata(branchCode, todayDate)">
              Generate
            </v-btn>

            <download-excel
              :data="json_data"
              :fields="json_fields"
              type="csv"
              :name="fileName"
              :fetch="downloadExcelCogsdata"
            >
              <v-btn fab flat medium color="black">
                <v-tooltip bottom>
                  <v-icon slot="activator" color="green darken-4">fas fa-file-excel</v-icon>
                  <span>Export</span>
                </v-tooltip>
              </v-btn>
            </download-excel>
          </v-toolbar>

          <loading :active.sync="isLoading" :is-full-page="fullPage" color="#7f0000" loader="bars"></loading>

          <!-- Output table removed as per requirement -->

          <back-to-top bottom="90px" right="90px">
            <v-btn class="red darken-4" dark absolute fab small>
              <v-icon>expand_less</v-icon>
            </v-btn>
          </back-to-top>
        </v-flex>
      </v-layout>
    </v-slide-y-transition>
  </v-container>
</template>

<script>
import moment from "moment";

export default {
  data() {
    return {
      branchCode: '',
      todayDate: moment().format("YYYY-MM-DD"),
      isLoading: false,
      fullPage: true,
      show: false,
      json_data: null,
      fileName: null,
      Cogslist: [],
      json_fields: {
        Departmentname: "Departmentname",
        ItemName: "ItemName",
        ItemCode: "ItemCode",
        BatchNo: "BatchNo",
        Mrp: "Mrp",
        Quantity: "Quantity",
        ExpiryDate: "ExpiryDate",
        SalesTax: "SalesTax",
        CostPrice: "CostPrice",
        UnitPrice: "UnitPrice"
      },
      tableHeaders: [
        "BRANCH", "PATIENT_MRN", "PATIENT_NAME", "PAYMENT_OR_REFUND_DATE", "BILL_NO",
        "RECEIPT_NO", "TOTAL_BILL_AMT", "CASH_AMOUNT", "CARD_AMOUNT", "CARD_SERVICE_CHARGE_AMOUNT",
        "CHEQUE_AMOUNT", "FUND_TRANSFER_AMOUNT", "PAYTM_AMOUNT", "DD_AMOUNT", "REFUND_CASH_AMOUNT",
        "REFUND_CARD_AMOUNT", "REFUND_CHEQUE_AMOUNT", "CREDIT_CHEQUE_AMOUNT", "CREDIT_CASH_AMOUNT",
        "PAYTM_CASH_AMOUNT", "PAYTM_FUND_AMOUNT", "DEPARTMENT", "PAYMENT_NATURE", "PAYMENT_MODE",
        "PAID_AMOUNT", "CREATEDBY", "PAYMENT_REFERENCE", "PAYMENT_DETAIL"
      ],
      tableKeys: [
        "BRANCH", "PATIENT_MRN", "PATIENT_NAME", "PAYMENT_OR_REFUND_DATE", "BILL_NO",
        "RECEIPT_NO", "TOTAL_BILL_AMT", "CASH_AMOUNT", "CARD_AMOUNT", "CARD_SERVICE_CHARGE_AMOUNT",
        "CHEQUE_AMOUNT", "FUND_TRANSFER_AMOUNT", "PAYTM_AMOUNT", "DD_AMOUNT", "REFUND_CASH_AMOUNT",
        "REFUND_CARD_AMOUNT", "REFUND_CHEQUE_AMOUNT", "CREDIT_CHEQUE_AMOUNT", "CREDIT_CASH_AMOUNT",
        "PAYTM_CASH_AMOUNT", "PAYTM_FUND_AMOUNT", "DEPARTMENT", "PAYMENT_NATURE", "PAYMENT_MODE",
        "PAID_AMOUNT", "CREATEDBY", "PAYMENT_REFERENCE", "PAYMENT_DETAIL"
      ]
    };
  },
  methods: {
    apiRequestCogsdata(branchCode, todate) {
      if (!branchCode) {
        alert("Please enter a valid 3-letter branch code");
        return;
      }

      this.isLoading = true;

      this.axios
        // .get(`http://localhost:8888/api-closingstock/${branchCode}/${todate}`)
        .get(`https://mis.dragarwal.com/api-closingstock/${branchCode}/${todate}`)
        .then(response => {
          this.processDatacogs(response.data);
          this.isLoading = false;
          if (response.data && response.data.result && response.data.result.cogs.length > 0) {
            alert("Data loaded... please download in Excel");
            this.fileName = `${branchCode}_closingstock_ason_${todate}.csv`;
            // this.show = true; // Table display disabled
          } else {
            alert("No data available");
          }
        })
        .catch(error => {
          this.isLoading = false;
          console.error("API Error:", error);
          alert("Failed to fetch data");
        });
    },
    processDatacogs(data) {
      this.Cogslist = data.result.cogs;
      this.json_data = this.Cogslist;
    },
    downloadExcelCogsdata() {
      return this.fileName ? this.Cogslist : null;
    }
  }
};
</script>

<style scoped>
.table-responsive {
  overflow-x: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/closingstock.vue